import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import QuoteInput from "./components/QuoteInput";
import QuoteResults from "./components/QuoteResults";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import IntakeForm from "./components/IntakeForm";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [leadId, setLeadId] = useState(null);
  const [leadData, setLeadData] = useState(null);
  const [quoteData, setQuoteData] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if token exists
    const token = localStorage.getItem("admin_token");
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLeadSubmit = (id, data) => {
    setLeadId(id);
    setLeadData(data);
  };

  const handleQuoteSubmit = (data) => {
    setQuoteData(data);
  };

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    setIsAuthenticated(false);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage onLeadSubmit={handleLeadSubmit} />} />
          <Route 
            path="/quote" 
            element={
              leadId ? (
                <QuoteInput leadId={leadId} onQuoteSubmit={handleQuoteSubmit} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/results" 
            element={
              quoteData ? (
                <QuoteResults data={quoteData} leadData={leadData} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/admin/login" 
            element={
              !isAuthenticated ? (
                <AdminLogin onLogin={handleLogin} />
              ) : (
                <Navigate to="/admin/dashboard" replace />
              )
            } 
          />
          <Route 
            path="/admin/dashboard" 
            element={
              isAuthenticated ? (
                <AdminDashboard onLogout={handleLogout} />
              ) : (
                <Navigate to="/admin/login" replace />
              )
            } 
          />
          <Route path="/intake" element={<IntakeForm />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;